import dayjs from "dayjs"
import utc from "dayjs/plugin/utc"
import timezone from "dayjs/plugin/timezone"

dayjs.extend(utc)
dayjs.extend(timezone)

// Tags live in their own table, so the API returns them as a tag_details array
// of { tag, created } objects rather than a comma separated string. Everything
// that reads tags goes through here, so an untagged config and one with an
// empty array look the same to callers.
export function getTagsFromDetails(tagDetails) {
  if (!Array.isArray(tagDetails)) {
    return []
  }

  return tagDetails.map(detail => (detail?.tag ?? "").trim()).filter(tag => tag.length > 0)
}

export function getConfigTags(config) {
  return getTagsFromDetails(config?.tag_details)
}

// The comma separated form, for the places that still need a single string:
// the config editors (the API takes tags back that way), CSV cells and sorting.
export function getConfigTagsText(config) {
  return getConfigTags(config).join(", ")
}

// New SSD is the one tag whose created date carries meaning: it records when
// the drive was swapped, so the date is shown beside the tag wherever the tag
// appears, and the trip assignments report only counts trips that ran after it.
const NEW_SSD_TAG = "new ssd"

export function isNewSsdTag(tag) {
  return (tag || "").trim().toLowerCase() === NEW_SSD_TAG
}

// The instant a config was given the New SSD tag, in milliseconds, or null if
// it has no dated one. Use this where both sides of a comparison carry a time;
// getNewSsdDate is the day-only form for display and for date-grained data.
export function getNewSsdCreatedMs(config) {
  const newSsd = (config?.tag_details || []).find(detail => isNewSsdTag(detail?.tag) && detail?.created)

  return newSsd ? dayjs.tz(newSsd.created, "Pacific/Auckland").valueOf() : null
}

// The day a config was given the New SSD tag, or "" if it has no dated one
export function getNewSsdDate(config) {
  const createdMs = getNewSsdCreatedMs(config)

  return createdMs === null ? "" : dayjs(createdMs).tz("Pacific/Auckland").format("YYYY-MM-DD")
}
